import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff4d0ece&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ff4d0ece&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4d0ece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff4d0ece')) {
      api.createRecord('ff4d0ece', component.options)
    } else {
      api.reload('ff4d0ece', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ff4d0ece&scoped=true", function () {
      api.rerender('ff4d0ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/costPlatform/components/widgets/basic_image/index.vue"
export default component.exports